export const ANOTHER_MODAL_OPEN = 'waitrose/common/ANOTHER_MODAL_OPEN';
export const ANOTHER_MODAL_CLOSED = 'waitrose/common/ANOTHER_MODAL_CLOSED';
export const CLOSE_MODAL = 'waitrose/common/CLOSE_MODAL';
export const OPEN_MODAL = 'waitrose/common/OPEN_MODAL';
